"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeeksOfMonthPicker = void 0;
const toggle_1 = __importDefault(require("@opsbase/lib-general/utils/toggle"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const nth_1 = require("@opsbase/lib-time/helpers/nth");
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importDefault(require("react"));
const WeeksOfMonthPicker = (props) => {
    let { weeksOfMonth, multi = false, onChange } = props;
    const numWeeks = weeksOfMonth === null || weeksOfMonth === void 0 ? void 0 : weeksOfMonth.length;
    const handleClickWeek = (0, useCallforward_1.default)(v => () => {
        onChange(multi ? (0, toggle_1.default)(weeksOfMonth, v) : [v]);
    }, [onChange, multi, weeksOfMonth]);
    return (react_1.default.createElement(Horizontal_1.default, { gutter: true },
        react_1.default.createElement(Pane_1.default, { grow: true }),
        [1, 2, 3, 4, -1].map(n => {
            const isSelected = multi ? weeksOfMonth.indexOf(n) >= 0 : (weeksOfMonth === null || weeksOfMonth === void 0 ? void 0 : weeksOfMonth[0]) === n;
            return (react_1.default.createElement(Button_1.default, { key: `day-of-month-${n}`, bordered: true, small: true, margin: 1, color: isSelected ? lib_palette_1.default.secondary : lib_palette_1.default.White, noEvents: numWeeks <= 1 && isSelected, onClick: handleClickWeek(n), label: n > 0 ? (0, nth_1.nth)(n) : 'Last' }));
        }),
        react_1.default.createElement(Pane_1.default, { grow: true })));
};
exports.WeeksOfMonthPicker = WeeksOfMonthPicker;
exports.default = exports.WeeksOfMonthPicker;
